import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const COLORS = [
  "#8B5CF6", "#3B82F6", "#10B981", "#F59E0B", "#EF4444",
  "#06B6D4", "#EC4899", "#84CC16", "#6366F1", "#9CA3AF",
];

function formatLabel(key) {
  return key
    .replace(/_/g, " ")
    .replace(/^anthropic direct$/, "Anthropic Direct")
    .replace(/^anthropic bedrock$/, "Anthropic Bedrock")
    .replace(/^openai direct$/, "OpenAI Direct")
    .replace(/^google direct$/, "Google Direct")
    .replace(/^bedrock /, "Bedrock ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

const BreakdownPie = ({ title, data }) => {
  if (!data || Object.keys(data).length === 0) {
    return (
      <div className='flex-1 min-w-[180px]'>
        <p className='text-body-xs font-medium text-text-secondary mb-2'>{title}</p>
        <p className='text-caption text-text-tertiary'>No data</p>
      </div>
    );
  }

  const entries = Object.entries(data)
    .map(([name, value]) => ({ name, value: Math.round(value * 100) / 100 }))
    .filter((e) => e.value > 0);

  const total = entries.reduce((s, e) => s + e.value, 0);

  return (
    <div className='flex-1 min-w-[180px]'>
      <p className='text-body-xs font-medium text-text-secondary mb-2'>{title}</p>
      <div className='flex items-center gap-3'>
        <div className='w-[80px] h-[80px]'>
          <ResponsiveContainer width='100%' height='100%'>
            <PieChart>
              <Pie
                data={entries}
                dataKey='value'
                nameKey='name'
                cx='50%'
                cy='50%'
                innerRadius={18}
                outerRadius={36}
                strokeWidth={1}
              >
                {entries.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                formatter={(v) => `$${v.toFixed(2)}`}
                contentStyle={{
                  background: "#1a1a2e",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "11px",
                  color: "#e0e0e0",
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className='flex flex-col gap-0.5 overflow-hidden'>
          {entries.slice(0, 4).map((e, i) => (
            <div key={e.name} className='flex items-center gap-1.5 text-caption truncate'>
              <span
                className='w-2 h-2 rounded-full flex-shrink-0'
                style={{ backgroundColor: COLORS[i % COLORS.length] }}
              />
              <span className='truncate text-text-secondary'>{formatLabel(e.name)}</span>
              <span className='text-text-tertiary ml-auto flex-shrink-0'>
                {total > 0 ? Math.round((e.value / total) * 100) : 0}%
              </span>
            </div>
          ))}
          {entries.length > 4 && (
            <span className='text-caption text-text-tertiary'>+{entries.length - 4} more</span>
          )}
        </div>
      </div>
    </div>
  );
};

const CallerBreakdownCharts = ({ caller }) => {
  return (
    <div className='flex flex-wrap gap-6 py-3 px-4'>
      <BreakdownPie title='By Purpose' data={caller.by_purpose} />
      <BreakdownPie title='By Model' data={caller.by_model} />
      <BreakdownPie title='By API Route' data={caller.by_api_route} />
    </div>
  );
};

export default CallerBreakdownCharts;
